
export const INVOICE_DETAIL_DATA = [
  {
    id: 1,
    workflowName: "Custom Email",
    initiatorRole: "Super Admin",
    initiatorName: "John",
    sentDate: "19 Oct, 2022",
    sentTime: "04:20 AM",
    emailType: "Self",
    // social_worker: "Palwasha",
    // createdAt: 30 / 4 / 2011,
    // nextInspectionDate: 30 / 4 / 2011,
    // status: "John Doe",
  },
  {
    id: 2,
    workflowName: "Default Workflow",
    initiatorRole: "Manager",
    initiatorName: "Nick",
    sentDate: "19 Oct, 2022",
    sentTime: "10:20 AM",
    emailType: "System",
    // social_worker: "John",
    // createdAt: 30 / 4 / 2011,
    // nextInspectionDate: 30 / 4 / 2011,
    // status: "John Doe",
  },
  {
    id: 3,
    workflowName: "Custom Email",
    initiatorRole: "Admin",
    initiatorName: "Chris",
    sentDate: "19 Oct, 2022",
    sentTime: "04:20 AM",
    emailType: "Self",
    // social_worker: "John",
    // createdAt: 30 / 4 / 2011,
    // nextInspectionDate: 30 / 4 / 2011,
    // status: "John Doe",
  },
  {
    id: 4,
    workflowName: "Default Workflow",
    initiatorRole: "Manager",
    initiatorName: "John",
    sentDate: "19 Oct, 2022",
    sentTime: "08:20 AM",
    emailType: "System",
    // social_worker: "John",
    // createdAt: 30 / 4 / 2011,
    // nextInspectionDate: 30 / 4 / 2011,
    // status: "John Doe",
  },
  {
    id: 5,
    workflowName: "Default Workflow",
    initiatorRole: "Manager",
    initiatorName: "John",
    sentDate: "19 Oct, 2022",
    sentTime: "08:20 AM",
    emailType: "System",
    // social_worker: "John",
    // createdAt: 30 / 4 / 2011,
    // nextInspectionDate: 30 / 4 / 2011,
    // status: "John Doe",
  },
];
